import { action, payload } from 'ts-action'
import { IReport } from '@network/models/report.model'
import { IError, IPayload } from '@network/models/global.model'

export const ReportsFetching = action('ReportsFetching', payload<boolean>())

export const GetReports = action('GetReports', payload<IPayload<IReport[]>>())

export const GetReportsErrors = action('GetReportsErrors', payload<IError>())

export const ResetReports = action('ResetReports')
